// KeyFeatures.jsx

import React from "react";

const KeyFeatures = ({ title,features }) => {
  return (
    <div className="p-3">
      {title && (
        <h3 className="wordGradient font-semibold text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]  mb-2">
          {title}
        </h3>
      )}
      {/* <h3 className="text-white font-semibold mb-3 text-lg md:text-xl lg:text-2xl">
        Key Features
      </h3> */}

      <ul className="list-disc pl-6   text-xs md:text-sm  space-y-[1px] text-white">
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
    </div>
  );
};

const KeyFeaturesCard = ({ features }) => {
  return (
    <div className="">
      {/* <h3 className="text-white font-semibold mb-3 text-lg md:text-xl lg:text-2xl">
        Key Features
      </h3> */}

      <ul className="  text-xs md:text-sm  space-y-[10px] font-RobotoBold tracking-wide text-[#1B99D4]">
        {features.map((feature, index) => (
          <li
            key={index}
            className="rounded-2xl  w-full px-4 py-3 overflow-hidden bg-black border-[0.03rem]  border-[#444D61] group-hover:border-slate-700 relative z-20"
          >
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};

export  {KeyFeatures, KeyFeaturesCard};
